import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useState, useEffect, useRef } from 'react';
import RenderIcon from "./rendericon";


const CRMServiceCarousel = ({ content }) => {


    const [isVisible, setIsVisible] = useState(false);
    const componentRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            if (componentRef.current) {
                const top = componentRef.current.getBoundingClientRect().top;
                const windowHeight = window.innerHeight;
                if (top < windowHeight) {
                    setIsVisible(true);
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll(); // Check on mount in case the component is already in the viewport

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);



    const settings = {
        dots: true,
        infinite: true,
        centerMode: true,
        centerPadding: "60px",
        slidesToShow: 3,
        speed: 500,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        appendDots: dots => (
            <div>
                <ul className="flex justify-center mt-4">{dots}</ul>
            </div>
        ),
        customPaging: i => (
            <div className="w-4 h-4 bg-gray-400 rounded-full mx-2 transition-all duration-300 hover:bg-[#FEE600]"></div>
        ),
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    centerPadding: "20px",
                },
            },
        ],
    };

    return (
        <div className={`w-full py-20 transition-opacity duration-500 ${isVisible ? 'opacity-100' : 'opacity-0'}`} ref={componentRef}>
            <div className="lg:text-6xl md:text-3xl text-xl lg:px-[100px] md:px-[60px] px-[30px] text-yellow-500 font-bold mt-10 mb-20">
                CRM Services <span className="text-white">We Offer</span>
            </div>
            <Slider {...settings}>
                {content.data.map((service, index) => (
                    <div key={index} className="px-2 pt-4 pb-10">
                        <div className="p-6 h-[450px] bg-black/70 shadow-lg rounded-lg border border-yellow-500 transition-all duration-300 transform hover:scale-105 hover:mb-[-50px] hover:translate-y-5">
                            <div className=" flex items-center gap-5 mb-4 ">
                                <h3 className="text-2xl font-bold text-white flex-1">{service.title}</h3>
                                <RenderIcon icon={service.icon} className="text-4xl text-white" />
                            </div>
                            <p className=" text-white">{service.description}</p>
                        </div>
                    </div>
                ))}
            </Slider>





            <style jsx>{`
              .slick-dots li.slick-active div {
               background-color: #FEE600 !important;
              }
            `}</style>



        </div>
    );
};

export default CRMServiceCarousel;
